const Module = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "icon": 'Icon',
    "status": "Status",
    "priority": "Priority",
    "search": "Search",

    // BUTTON
    "add": "Create",
    "submit": "Save",
    "update": "Edit",
    "apply": "Apply",
    "clear": "Clear",
    "cancel": "Cancel",
    "ok": "Ok",

    // PAGE HEADER
    "module": "Module",
    "filter": "Filter",

    // TOOLTIP
    "download": "Download",
    "pdf": "PDF",
    "excel": "Excel",
    "edit": "Edit",
    "delete": "Delete",

    // TOAST
    "success_add": "Created Successfully",
    "success_update": "Edited Successfully",
    "wrong": "Something went wrong",

    // SWEET ALERT
    "confirm_text": "Are You Sure Want To Delete Module?",
    "delete_text": "Deleted Successfully",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_status": "Select Status",
    "error_priority_positive": "Priority Should be Positive",
    "error_priority_required": "Enter Priority",
    "error_priority_type_error": "Enter only Number",
    "error_icon": "Enter Icon Name",

    // TABLE HEADER
    "table_no": "NO",
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_priority": "PRIORITY",
    "table_status": "STATUS",
    "table_action": "ACTION",

}

export default Module;
